import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { applicationReviewsKey } from "@/hooks/apis/queries/useApplicationReviewsInfiniteQuery/constants";
import { useTranslations } from "@/hooks/common/useTranslations";

import { applicationsApiHandler } from "@/services/apiHandlers/applications";
import type { IDeleteReviewRequest } from "@/services/apiHandlers/applications/types";

const useDeleteReviewMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslations("SingleAppPage");
  const { mutateAsync: deleteReview, ...mutationSpreadParams } = useMutation({
    mutationFn: ({ reviewId }: IDeleteReviewRequest) =>
      applicationsApiHandler.deleteReview({ reviewId }),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: [applicationReviewsKey] });

      toast.success(t("deletedReview"));
    },
  });

  return {
    deleteReview,
    ...mutationSpreadParams,
  };
};

export default useDeleteReviewMutation;
